import { databaseRef } from 'config'

export const getUserById = (userId: string) => {
  return new Promise((resolve, reject) => {
    databaseRef
      .child(`users/${userId}`)
      .once('value')
      .then(snapshot => {
        const userData = snapshot.val()
        if (userData) {
          resolve(userData)
        } else {
          reject('no user')
        }
      })
      .catch(error => reject(error))
  })
}



// WEBPACK FOOTER //
// ./src/store/user/actions/getUserById.action.ts